module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GE-2222b4452b5db04bccb5514f7a9bab53.png";